export default __webpack_public_path__ + "static/media/preferedvendor_1.494b455c.png";